export const ENABLE_USER_BODY = {
  callbackUrl: `${window.location.origin}/auth/activate-account`,
  parameterName: 'token',
};
